// Module
var code = "<div class=\"widget-content relative\"> <wt-loading-panel is-loading=\"vm.isLoading\" message=\"vm.loadingMessage\"> </wt-loading-panel> <wt-multi-bullet-chart class=\"bullet-chart flex-directive\" id=\"{{'reconciliationResults' + vm.item.guid}}\" kpi-list=\"vm.kpiVmList\" ratio=\"vm.ratio\"> </wt-multi-bullet-chart> </div>";
// Exports
module.exports = code;